<template>
	<Modal :disableClose="disableClose" @close="$emit('close')">
		<div class="add-to-cart-modal">
			<h4 class="add-to-cart-modal__title">{{ title }}</h4>
			<p class="add-to-cart-modal__text">{{ text }}</p>
			<Button
				v-for="(button, i) in buttons"
				:key="i"
				@click.native="click(button.type)"
				:color="button.color"
			>
				{{ $t('cart.' + button.type) }}
			</Button>
		</div>
	</Modal>
</template>

<script>
import store from '../../vueX/store'
import Button from '../atoms/Button'
import Modal from '../molecules/Modal'

export default {
	name: 'AddToCartModal',
	store,
	components: {
		Button,
		Modal
	},
	props: {
		disableClose: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		buttons: {
			type: Array,
			default: () => []
		},
		routeTo: {
			type: Object,
			default: () => ({
				value1: '',
				value2: '',
				value3: ''
			})
		}
	},
	methods: {
		addProductsToCart() {
			//Lägger produkten i varukorgen
			const routeName = this.$router.currentRoute.name.toUpperCase()
			const actionName = 'ADD_CART_' + routeName
			store
				.dispatch(actionName, store.state.productList.selectedItems)
				.then(() => {
					this.loading = false
				})
		},
		click(type) {
			if (type == 'addLeave') {
				this.addProductsToCart()
				store.dispatch('REMOVE_ALL_PRODUCT_SELECTED_ITEMS')
				this.$router.push({name: 'addtocart'})
			} else if (type == 'clearLeave') {
				store.dispatch('REMOVE_ALL_PRODUCT_SELECTED_ITEMS')
				this.$router.push(this.routeTo)
			} else if (type == 'add') {
				this.addProductsToCart()
				store.dispatch('REMOVE_ALL_PRODUCT_SELECTED_ITEMS')
				this.$emit('close')
			} else if (type == 'close') {
				this.$emit('close')
			}
		}
	}
}
</script>

<style scoped lang="scss">
.add-to-cart-modal {
	max-width: 383px;
	h4.add-to-cart-modal__title {
		max-width: 340px;
		font-size: 28px;
		line-height: 36px;
		margin-bottom: 20px;
	}
	p.add-to-cart-modal__text {
		margin-bottom: 38px;
	}
	button {
		margin: 0 10px 0 0;
		&:last-child {
			margin: 0;
		}
	}
}
</style>
